export default {
  bdtx_get_exam_store: '/exam-template/index/search',
  bdtx_get_exam_template: '/exam-template/get',
  bdtx_update_exam_template: '/exam-template/update',
};
